module.exports = __webpack_public_path__ + "media/stylesheets/opensans600-c5dd4adf257ad349ef4b4245edbc1266.woff2";